export var Channel;
(function (Channel) {
    Channel["cars"] = "cars";
    Channel["vans"] = "vans";
    Channel["bikes"] = "bikes";
    Channel["motorhomes"] = "motorhomes";
    Channel["caravans"] = "caravans";
    Channel["trucks"] = "trucks";
    Channel["plant"] = "plant";
    Channel["farm"] = "farm";
    Channel["cycles"] = "cycles";
})(Channel || (Channel = {}));
export var Environment;
(function (Environment) {
    Environment["local"] = "local";
    Environment["dev"] = "dev";
    Environment["preprod"] = "preprod";
    Environment["prod"] = "prod";
})(Environment || (Environment = {}));
export var Bucket;
(function (Bucket) {
    Bucket["desktop"] = "desktop";
    Bucket["premiummobile"] = "premiummobile";
})(Bucket || (Bucket = {}));
export var Platform;
(function (Platform) {
    Platform["desktop"] = "desktop";
    Platform["mobile"] = "mobile";
})(Platform || (Platform = {}));
